var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpstairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7603 12.0116L45.7605 47.0922L10.0966 47.0923L10.0964 12.0118L45.7603 12.0116ZM45.7603 7.00009L10.0964 7.00028C7.2942 7.0003 5.00154 9.25549 5.00155 12.0118L5.00174 47.0924C5.00176 49.8487 7.29445 52.1039 10.0966 52.1039L45.7605 52.1037C48.5627 52.1036 50.8553 49.8485 50.8553 47.0921L50.8551 12.0116C50.8551 9.25524 48.5624 7.00007 45.7603 7.00009ZM43.2129 14.5174L31.9533 14.5174L31.9533 22.8616L25.381 22.8616L25.381 31.2058L18.8087 31.2058L18.8087 39.575L12.644 39.5751L12.644 44.5866L23.9036 44.5865L23.9035 36.2424L30.4759 36.2423L30.4758 27.8982L37.0482 27.8981L37.0481 19.5289L43.2129 19.5289L43.2129 14.5174Z",
    fill: "#B2CE53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0989 29.9999L34.0989 31.6395L39.5015 31.6395L29.9998 41.1412L31.1558 42.2972L40.6574 32.7954L40.6574 38.198L42.2971 38.198L42.297 29.9998L34.0989 29.9999Z",
    fill: "#B2CE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpstairs);
export default __webpack_public_path__ + "static/media/Upstairs.8f260b02e42f659faa0a33cf7fb3a5d7.svg";
export { ForwardRef as ReactComponent };